module.exports = __webpack_public_path__ + "media/images/illustrations/corner-4-e9bba510874b06abb0414fff2f232021.png";